import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import avatar5 from '../../assets/img/avatar_5.svg';
import arrowWhiteIcon from '../../assets/img/icons/arrow_right_white.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import AssigneeTooltip from '../../components/Tooltip/AssigneeTooltip';
import {
  TableItem,
  TableRowAndBudgetCollapseContainer,
} from '../../styledComponents/ProjectsNew';
import {
  CommonFlex,
  Container,
  TableText,
} from '../../styledComponents/common';
import { ComplaintsTable } from '../../styledComponents/complaints';
import { ExpandIcon, ProjectExpandButton } from '../Projects/projectsStyles';
import TaskEvidence from '../Tasks/TaskDetails/taskEvidence';
import { AssigneeRoundImg, CollapseSection } from '../Tasks/tasksStyles';

const ComplaintsList = ({
  handleChangePage,
  isLoading,
  complaintsList = [],
  selectedComplaint,
  selectComplaint,
}) => {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (complaintsList && complaintsList.length > 0) {
      setList(complaintsList);
    } else {
      setList([]);
    }
  }, [complaintsList]);

  useEffect(() => {
    if (searchTerm) {
      const filteredList = complaintsList.filter(complaint =>
        complaint.description.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setList(filteredList);
    } else {
      setList(complaintsList);
    }
  }, [searchTerm]);



  return (
    <Container style={{ paddingBottom: '20px', overflowX: 'auto' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : list && list?.length > 0 ? (
        <>
          <ComplaintsTable
            heading
            style={{
              textAlign: 'center',
            }}
          >
            <TableItem minWidth="150px">
              <TableText>{t('complaint_no')}</TableText>
            </TableItem>
            <TableItem minWidth="150px">
              <TableText>{t('public_zone')}</TableText>
            </TableItem>
            <TableItem minWidth="150px">
              <TableText>{t('office')}</TableText>
            </TableItem>
            <TableItem minWidth="150px">
              <TableText>{t('camp_number')}</TableText>
            </TableItem>
            <TableItem minWidth="150px">
              <TableText>{t('reporter')}</TableText>
            </TableItem>
            <TableItem minWidth="150px">
              <TableText>{t('date_and_time')}</TableText>
            </TableItem>
            <TableItem minWidth="150px">
              <TableText>{t('employee_description')}</TableText>
            </TableItem>
            <TableItem />
          </ComplaintsTable>
          {list?.map(complaint => {
            return (
              <TableRowAndBudgetCollapseContainer key={complaint.id}>
                <ComplaintsTable
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <TableItem minWidth="150px">
                    <TableText
                      hoverPointer
                      hoverUnderline
                      name
                      fontWeight={
                        selectedComplaint &&
                        selectedComplaint.id === complaint.id &&
                        '600'
                      }
                      onClick={() => selectComplaint(complaint)}
                    >
                      {complaint.complaints_no}
                    </TableText>
                  </TableItem>{' '}
                  <TableItem minWidth="150px">
                    <TableText name>{complaint.public_zone?.name || '-'}</TableText>
                  </TableItem>
                  <TableItem minWidth="150px">
                    <TableText name>{complaint.office?.name || '-'}</TableText>
                  </TableItem>
                  <TableItem minWidth="150px">
                    <TableText name>{complaint.camp_number || '-'}</TableText>
                  </TableItem>{' '}
                  <TableItem
                    minWidth="150px"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    {complaint.created_by?.id ? (
                      <AssigneeRoundImg
                        image={complaint.created_by.avatar || avatar5}
                      >
                        <AssigneeTooltip
                          toolTipText={`${complaint.created_by.first_name || ''}${
                            complaint.created_by.last_name
                              ? ` ${complaint.created_by.last_name}`
                              : ``
                          }`}
                          phone={complaint.created_by.phone}
                          top="-60px"
                          left="-55px"
                        />
                      </AssigneeRoundImg>
                    ) : null}
                  </TableItem>
                  <TableItem minWidth="150px">
                    <TableText name>
                      {moment(complaint.created_at).format('DD/MM/YYYY HH:mm')}
                    </TableText>
                  </TableItem>
                  <TableItem minWidth="150px">
                    <TableText name>{complaint.description}</TableText>
                  </TableItem>
                  <TableItem alignContent="start">
                    <CommonFlex gap="12px" wrap="wrap">
                      <ProjectExpandButton
                        margin="0"
                        onClick={() => {
                          if (selectedComplaint?.id === complaint.id) {
                            selectComplaint(null);
                          } else selectComplaint(complaint);
                        }}
                      >
                        <ExpandIcon
                          src={arrowWhiteIcon}
                          alt=""
                          open={
                            selectedComplaint &&
                            selectedComplaint.id === complaint.id
                          }
                        />
                      </ProjectExpandButton>
                    </CommonFlex>
                  </TableItem>
                </ComplaintsTable>
                <CollapseSection open={selectedComplaint?.id === complaint.id}>
                  <Container padding="30px" borderColor="#977C70" margin="20px">
                    <TaskEvidence evidences={complaint.evidences || []} />
                  </Container>
                </CollapseSection>
              </TableRowAndBudgetCollapseContainer>
            );
          })}
        </>
      ) : (
        <NoDataComponent
          title={t('no_complaints_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default ComplaintsList;
